// import React from "react";
// import HeroSection from "../Components/HeroSection";
// import CardInfo from "../Components/CardInfo";
// // import CardBatch from "../Components/CardBatch";
// import MissionSection from "../Components/MissionSection";
// import VisionSection from "../Components/VisionSection";
// import ClientsSection from "../Components/ClientsSection";

// function Home() {
//   return (
//     <div className="bg-primary-color">
//       <HeroSection />
//       <MissionSection />
//       <VisionSection />
//       <ClientsSection />
//       <h2 className="text-gray-800 text-center text-2xl font-bold py-5 sm:py-6 md:py-8 lg:py-9 xl:py-10 2xl:py-11">
//         Services offered by BrandFlow
//       </h2>
//       <div className="flex flex-wrap justify-center items-center">
//         <CardInfo
//           imageUrl="Icons/Digital Marketing.png"
//           imageUrlHover="Icons/Digital Marketing Inverted.png"
//           description="Digital marketing used strategically helps startups along in establishing their online presence and advancing their brand visibility. We employ everything from social media marketing and email promotions through content creation and SEO to make sure your brand reaches the right audience efficiently."
//         />
//         <CardInfo
//           imageUrl="Icons/Market Entry Support.png"
//           imageUrlHover="Icons/Market Entry Support Inverted.png"
//           description="Entering a new market is no simple matter, especially in a busy city like Mumbai. Our market-entry support services include market research, competitor analysis, and infrastructure setup, everything ensuring that your brand launches and grows smoothly in Mumbai."
//         />
//         <CardInfo
//           imageUrl="Icons/Online Platform Management.png"
//           imageUrlHover="Icons/Online Platform Management Inverted.png"
//           description="Managing one-click platforms is crucial for a seamless customer experience. We manage your website as well as e-commerce portals and social channels, ensuring that they are running fine and optimizing engagement, sales, and customer interaction."
//         />
//         <CardInfo
//           imageUrl="Icons/Brand Collaboration Marketplace.png"
//           imageUrlHover="Icons/Brand Collaboration Marketplace Inverted.png"
//           description="Growth through collaboration. Our exclusive marketplace connects your startup with countless brands and influencers for collaborations of mutual benefit, helping amplify the reach of your products and establish a foothold inside the Mumbai ecosystem."
//         />
//         <CardInfo
//           imageUrl="Icons/Public Relations  PR .png"
//           imageUrlHover="Icons/Public Relations  PR  Inverted.png"
//           description="We ensure that your startup gets its due attention. Media outreach, event management, and crisis communication strategies are just a few of our tricks meant to build and maintain a positive image of your brand."
//         />
//         <CardInfo
//           imageUrl="Icons/Paid Advertisement Solutions.png"
//           imageUrlHover="Icons/Paid Advertisement Solutions Inverted.png"
//           description="Leverage your highest ROI with our focused and data-driven ad solutions. Google Ads, social media ads, or influencer campaigns, we design and implement advertising strategies that suit your brand and audience."
//         />
//         <CardInfo
//           imageUrl="Icons/Pay Attention to Cash Flow and Sales.png"
//           imageUrlHover="Icons/Pay Attention to Cash Flow and Sales Inverted.png"
//           description="At Brand Flow, cash flow and sales are the lifeblood of any startup. We do provide tools, insights, and strategies that will optimize your financial health, improve your sales process, and assure continued profitability."
//         />
//         {/* <CardBatch
//           imageUrl="Icons/Batch 1.png"
//           imageUrlHover="Icons/Batch 1 Invert.png"
//           timings="Timings: 7pm to 8pm"
//           days="Days: Wednesdays & Fridays"
//           ageGroup="Age Group: 5-16 years"
//           fees="Fees: Rs. 2000 per month"
//           location="Location: Nidhivan Lawn Near Witty International School, Pawan Baug, Chincholi Bundar, Malad West, Mumbai"
//           locationUrl="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.4206041547727!2d72.844234425967!3d19.17682309879814!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b79de3be6f35%3A0x20e4a67f148b3ab0!2sNidhivan%20Turf!5e0!3m2!1sen!2sin!4v1714231423911!5m2!1sen!2sin"
//         />
//         <CardBatch
//           imageUrl="Icons/Batch 2.png"
//           imageUrlHover="Icons/Batch 2 Invert.png"
//           timings="Timings: 8pm to 9pm"
//           days="Days: Tuesdays & Thursdays"
//           ageGroup="Age Group: 5-16 years"
//           fees="Fees: Rs. 2000 per month"
//           location="Location: The Bhoomi Park Society, Club House Turf, Near Billabong school, Jan Kalyan, Malad West, Mumbai"
//           locationUrl="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d666.0695062338838!2d72.82064167224142!3d19.20139843929915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b6bb8da40a1d%3A0xc9522614db9c6eca!2sBhoomi%20Park%20Phase%203%20A%20Wing!5e0!3m2!1sen!2sin!4v1714232108054!5m2!1sen!2sin"
//         /> */}
//       </div>
//     </div>
//   );
// }

// export default Home;

import React from "react";
import HeroSection from "../Components/HeroSection";
import CardInfo from "../Components/CardInfo";
import MissionSection from "../Components/MissionSection";
import ClientsSection from "../Components/ClientsSection";
import {
  Megaphone,
  MapPin,
  Globe,
  Handshake,
  Mic,
  BadgeDollarSign,
  TrendingUp,
} from "lucide-react";

function Home() {
  return (
    <div className="bg-primary-color">
      <HeroSection />
      <MissionSection />

      <h2
        id="services"
        className="text-white text-center text-3xl font-extrabold pt-12 tracking-wide bg-primary-color"
      >
        Services offered by BrandFlow
      </h2>
      <div className="bg-primary-color w-full py-12">
        <div className="flex flex-wrap justify-center items-stretch gap-8 px-4">
          <CardInfo
            title="Digital Marketing"
            description="Strategic digital marketing solutions to build and scale your brand’s online presence using SEO, content creation, social media, and targeted campaigns."
            Icon={Megaphone}
          />

          <CardInfo
            title="Market Entry Support"
            description="Helping startups launch successfully in Mumbai with market research, competitor analysis, and operational setup guidance."
            Icon={MapPin}
          />

          <CardInfo
            title="Online Platform Management"
            description="Professional management of websites, e-commerce stores, and social channels to improve customer experience and conversions."
            Icon={Globe}
          />

          <CardInfo
            title="Brand Collaboration Marketplace"
            description="Connect with brands and influencers to grow visibility, collaborations, and meaningful partnerships through our marketplace."
            Icon={Handshake}
          />

          <CardInfo
            title="Public Relations (PR)"
            description="Complete media outreach, event management, and PR strategy to ensure your brand gets the attention it deserves."
            Icon={Mic}
          />

          <CardInfo
            title="Paid Advertisement Solutions"
            description="High ROI ads through data-driven Google Ads, social ads, influencer campaigns, and targeted promotional funnels."
            Icon={BadgeDollarSign}
          />

          <CardInfo
            title="Cash Flow & Sales Management"
            description="Tools, insights, and strategies to ensure healthy cash flow, optimized sales processes, and sustainable business growth."
            Icon={TrendingUp}
          />
        </div>
      </div>
      <ClientsSection />
    </div>
  );
}

export default Home;
